<template lang='pug'>
  section
    above-fold
    software-changed
    powerful-platform
    feature-details
    open-source
    turing-complete
    build-anywhere
    design-for-future
    integrations
    call-to-action
    video-demo
    request-trial
</template>

<script>
import AboveFold from '../components/AboveFold';
import SoftwareChanged from '../components/SoftwareChanged';
import WhatWeDo from '../components/WhatWeDo';
import WhoWeServe from '../components/WhoWeServe';
import RequestTrial from '../components/RequestTrial';
import TopArch from '../components/TopArch';
import PowerfulPlatform from '../components/PowerfulPlatform';
import FeatureDetails from '../components/FeatureDetails';
import OpenSource from '../components/OpenSource';
import TuringComplete from '../components/TuringComplete';
import BuildAnywhere from '../components/BuildAnywhere';
import DesignForFuture from '../components/DesignForFuture';
import Integrations from '../components/Integrations';
import CallToAction from '../components/CallToAction';
import VideoDemo from '../components/VideoDemo';
import RequestTrialButton from '../components/RequestTrialButton';

export default {
  components: {
    RequestTrialButton,
    VideoDemo,
    CallToAction,
    Integrations,
    DesignForFuture,
    BuildAnywhere,
    TuringComplete,
    OpenSource,
    FeatureDetails,
    TopArch,
    RequestTrial,
    WhoWeServe,
    WhatWeDo,
    AboveFold,
    SoftwareChanged,
    PowerfulPlatform
  },
  name: 'Home',
  data() {
    return {
      msg: 'Home'
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
